import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-settings/')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!user || user.role !== 'admin') {
      throw redirect({
        to: '/time-entry',
      });
    }
    throw redirect({
      to: '/admin-settings/logged-hours',
    });
  },
});
